module.exports = __webpack_public_path__ + "static/media/lucasaold.55215c39.jpg";